/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class HeatstackFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return HeatstackFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<HeatstackFeatureFlagsWithDefaults>): HeatstackFeatureFlagsWithDefaults {
        let obj = Object.assign(new HeatstackFeatureFlagsWithDefaults(), model);
        HeatstackFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<HeatstackFeatureFlagsWithDefaults>): HeatstackFeatureFlagsWithDefaults {
        if (!model) return null;
        return HeatstackFeatureFlagsWithDefaults.newInstance(<HeatstackFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: HeatstackFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.HeatstackFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: HeatstackFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, HeatstackFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    heat_2601_a_cost_rate_optimization: boolean = false;

    /**
     * Flag's default value
     */
    heat_2601_a_azure_aks_cluster: boolean = false;

    /**
     * Flag's default value
     */
    heat_2601_a_google_gke_cluster: boolean = false;

    /**
     * Flag's default value
     */
    heat_2602_a_master_account_policy_config: boolean = true;

    /**
     * Flag's default value
     */
    heat_2603_b_ai_observability_119985: boolean = false;

}
